// extracted by mini-css-extract-plugin
module.exports = {"Container":"TitleSubtitle_Container__TgBaN","TopLabel":"TitleSubtitle_TopLabel__1VRpZ","BottomLabel":"TitleSubtitle_BottomLabel___qP9A"};